<template>
  <div class="new-cls content">
    <Tabs
      :tabsList="tabsList"
      style="padding: 0 24px"
      :activeName="activeVal"
      @tab-click="handleChange"
    >
    </Tabs>

    <BaseInfoView v-if="activeVal == '1'" />
    <ParamsSettingView v-if="activeVal == '2'" />
    <HolidayConfigView v-if="activeVal == '3'" />
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";

import BaseInfoView from "./children/BaseInfo.vue";
import ParamsSettingView from "./children/ParamsSetting.vue";
import HolidayConfigView from "./children/HolidayConfig.vue";

export default {
  components: { Tabs, BaseInfoView, ParamsSettingView, HolidayConfigView },
  data() {
    return {
      activeVal: "1",
      tabsList: [
        {
          name: "1",
          label: "基本参数",
          value: 0,
        },
        {
          name: "2",
          label: "参数设置",
          value: 0,
        },
        {
          name: "3",
          label: "统一节假日设置",
          value: 0,
        },
      ],
    };
  },
  methods: {
    handleChange(val) {
      this.activeVal = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #fff;
  height: calc(100vh - 140px);
  ::v-deep .el-tabs__item {
    padding: 0 12px;
    margin-right: 0px;
  }
}
</style>
